import type { ReactNode } from 'react';
import type { LucideIcon } from 'lucide-react';
import { cn } from '@/lib/utils';
import { ACCENT_MARK_CLASS } from '@/styles/accentMark';
import { SOFT_BLUE_GRADIENT_CLASS } from '@/styles/softBlueSurface';

const TINTED_HEADER_CLASS = cn(
  '-mx-5 -mt-5 rounded-t-2xl border-b border-primary/10 px-5 py-3.5',
  SOFT_BLUE_GRADIENT_CLASS,
);

interface DetailPanelProps {
  title: string;
  icon: LucideIcon;
  actions?: ReactNode | undefined;
  hasTintedHeader?: boolean | undefined;
  children: ReactNode;
}

export function DetailPanel({
  title,
  icon: Icon,
  actions,
  hasTintedHeader = false,
  children,
}: DetailPanelProps) {
  return (
    <section
      aria-label={title}
      className="flex flex-col gap-4 rounded-2xl bg-card p-5 shadow-sm ring-1 ring-primary/10"
    >
      <div
        className={cn(
          'flex flex-wrap items-center justify-between gap-3',
          hasTintedHeader && TINTED_HEADER_CLASS,
        )}
      >
        <div className="flex items-center gap-2.5">
          <span
            className={cn(
              'flex size-8 shrink-0 items-center justify-center rounded-lg',
              ACCENT_MARK_CLASS,
            )}
          >
            <Icon className="size-4" aria-hidden />
          </span>
          <h2 className="text-sm font-semibold">{title}</h2>
        </div>
        {actions}
      </div>
      {children}
    </section>
  );
}
